import { render, staticRenderFns } from "./PDFPage.vue?vue&type=template&id=16f5c792"
import script from "./PDFPage.vue?vue&type=script&lang=ts"
export * from "./PDFPage.vue?vue&type=script&lang=ts"
import style0 from "./PDFPage.vue?vue&type=style&index=0&id=16f5c792&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports